import {
  addProcedure,
  deleteProcedure,
  getMiddleProcedures,
  updateMiddleProceduresSeq,
  updateProcedure
} from '@/utils/request'
import vue from '@/main'

const state = {
  middleProcedureList: []
}

const mutations = {
  RESET (state) {
    state.middleProcedureList = []
  },
  UPDATE_PROCEDURES (state, procedures) {
    state.middleProcedureList = procedures
    // 更新看板数据
    this.dispatch('work/getKanbanWorks', 0)
  }
}

const actions = {
  middleProcedureList ({ state }) {
    return new Promise((resolve) => {
      getMiddleProcedures().then(response => {
        if (state.middleProcedureList.length !== 0) {
          resolve(state.middleProcedureList)
        } else {
          state.middleProcedureList = response.data
          resolve(response.data)
        }
      })
    })
  },
  procedureById ({ commit, state }, id) {
    for (const procedure of state.middleProcedureList) {
      if (procedure.id === id) return vue.$_.cloneDeep(procedure)
    }
    return null
  },
  update ({ commit, dispatch, state }, procedures) {
    return new Promise((resolve) => {
      updateMiddleProceduresSeq(procedures).then(() => {
        commit('UPDATE_PROCEDURES', procedures)
        resolve()
      })
    })
  },
  updateOne ({ state }, procedure) {
    return new Promise((resolve) => {
      updateProcedure(procedure).then(() => {
        for (const cur of state.middleProcedureList) {
          if (cur.id === procedure.id) {
            Object.assign(cur, procedure)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ state, commit, dispatch }, procedure) {
    return new Promise((resolve) => {
      addProcedure(procedure).then((response) => {
        commit('UPDATE_PROCEDURES', response.data)
        resolve()
      })
    })
  },
  delete ({ state }, procedureId) {
    return new Promise((resolve) => {
      deleteProcedure(procedureId).then(() => {
        for (const i in state.middleProcedureList) {
          if (state.middleProcedureList[i].id === procedureId) {
            state.middleProcedureList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
